/* eslint-disable */

const loadScript = async (src) => {
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }
  const script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
  await new Promise((resolve) => (script.onload = resolve));
};

export async function initStringeeSDK(payload) {
  try {
    // 1. Load Stringee SDK script
    await loadScript('https://static.stringee.com/stringeex/web_phone/latest/js/StringeeSoftPhone-lastest.js');

    validateStringeeSDK();


    var config = {
      showMode: 'none', // full | min | none
      bottom: 100, // Đặt khoảng cách từ dưới lên
      right: 20, // Đặt khoảng cách từ phải vào
      arrowDisplay: 'bottom', // top | bottom | none
      arrowLeft: 230,
      fromNumbers: [
        // { alias: 'Số-1', number: '+842871061791' },
      ]
    };

    StringeeSoftPhone.init(config);

    StringeeSoftPhone.connect(payload.accessToken);

    registerEvent();
  } catch (error) {
    console.error('initStringeeSDK -> error:', error);
  }
}

function validateStringeeSDK() {
  if (typeof StringeeSoftPhone == 'undefined') {
    throw new Error('Stringee SDK not loaded!');
  }
}

export function unRegisterStringeeSDK() {
  try {
    if (!StringeeSoftPhone) {
      console.warn('StringeeClient chưa được khởi tạo.');
      return;
    }
    validateCallSDK();
    StringeeSoftPhone.disconnect();
    console.log('Đã ngắt kết nối Stringee SDK.');
  } catch (error) {
    console.error('unRegisterStringeeSDK -> error:', error);
  }
}

function registerEvent() {
  StringeeSoftPhone.on('endCallBtnClick', (data) => {
    document.dispatchEvent(new CustomEvent('Stringee_ended', {
      detail: data
    }))
  });

  // StringeeSoftPhone.on('ended', (data) => {
  //   document.dispatchEvent(new CustomEvent('Stringee_endedCall', {
  //     detail: data
  //   }))
  // });
  StringeeSoftPhone.on('ended', (data) => {
    document.dispatchEvent(new CustomEvent('Stringee_endedCall', {
      detail: data
    }))
  });

  StringeeSoftPhone.on('info', (data) => {
    document.dispatchEvent(new CustomEvent('Stringee_info', {
      detail: data
    }))
  });

  StringeeSoftPhone.on('signalingstate', function (state) {
    document.dispatchEvent(new CustomEvent('Stringee_state', {
      detail: state
    }))
  });

  StringeeSoftPhone.on('requestnewtoken', (data) => {
    document.dispatchEvent(new CustomEvent('Stringee_newtoken', {
      detail: data
    }))
  });

  StringeeSoftPhone.on('makeOutgoingCallBtnClick', function (fromPhone, toPhone, callType) {
    document.dispatchEvent(new CustomEvent('Stringee_call', {
      detail: {
        fromPhone: fromPhone,
        toPhone: toPhone,
        callType: callType
      }
    }))
  });

  StringeeSoftPhone.on('connect', function (res) {
    document.dispatchEvent(new CustomEvent('Stringee_connect', {
      detail: res
    }))
  });

  StringeeSoftPhone.on('incomingCall', (incomingCall) => {
    document.dispatchEvent(new CustomEvent('Stringee_incommingcall', {
      detail: incomingCall
    }))
  });

  StringeeSoftPhone.on('answerIncomingCallBtnClick', (incomingCall) => {
    document.dispatchEvent(new CustomEvent('Stringee_incommingcallAnswered', {
      detail: incomingCall
    }))
  });
  
  StringeeSoftPhone.on('incomingCallError', function(error) {
    console.log('Lỗi khi nhận cuộc gọi:', error);
  });

  StringeeSoftPhone.on('disconnect', function(error) {
    console.log('Ngắt kết nối:', error);
  });

  StringeeSoftPhone.on('otherdeviceauthen', function(error) {
    console.log('Xác thực thiết bị khác:', error);
  });

  StringeeSoftPhone.on('authen', function(data) {
    document.dispatchEvent(new CustomEvent('Stringee_authen', {
      detail: data
    }))
  });

  StringeeSoftPhone.on('beforeMakeCall', function(call, callType) {
    document.dispatchEvent(new CustomEvent('Stringee_beforeCall', {
      detail: {
        call: call,
        callType: callType
      }
    }))
  });

  StringeeSoftPhone.on('displayModeChange', function (event) {
    document.dispatchEvent(new CustomEvent('Stringee_changDisplayMode', {
      detail: event
    }))
  });
}
